import { createSlice } from '@reduxjs/toolkit';
import { saveBankDetailsApi, saveSellerBuyerDetailsApi } from '../api/signup';

interface UsersState {
  loading: boolean;
  currentRequestId: undefined | string;
  userData: any;
  error: any;
}

const initialState = {
  loading: false,
  currentRequestId: undefined,
  userData: null,
  error: null,
} as UsersState;

export const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    resetSignup: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase("RESET_ALL", (state, action) => {
        return initialState;
      })
      .addCase(saveSellerBuyerDetailsApi.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(saveSellerBuyerDetailsApi.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
          state.userData = action.payload?.data;
        }
      })
      .addCase(saveSellerBuyerDetailsApi.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
          state.error = action.error?.message || 'Something went wrong';
        }
      })
      .addCase(saveBankDetailsApi.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(saveBankDetailsApi.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
          state.userData = action.payload?.data;
        }
      })
      .addCase(saveBankDetailsApi.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentRequestId === requestId) {
          state.loading = false;
          state.currentRequestId = undefined;
          state.error = action.error?.message || 'Something went wrong';
        }
      })
      
      
  },
});

export const { resetSignup } = signupSlice.actions;

export default signupSlice.reducer;
